import * as React from "react";
import styled from "styled-components";
import { color } from "@conserveit/blocks";
import Preview from "./components/Preview";

// NOTE: This is an invisible wrapper that extends over the
// tip accent, so that hover is still active when the cursor
// moves from the trigger to the preview
const PreviewWrapper = styled.div`
  position: absolute;
  top: -40px;
  left: 10px;
  right: 0;
  height: 40px;
`;

const Trigger = styled.span`
  cursor: help;
  color: ${color.theme.primaryColor.action.primary};
  text-decoration: underline dotted ${color.theme.primaryColor.action.primary};
`;

const Container = styled.div`
  position: relative;
  display: inline-block;

  ${PreviewWrapper} {
    display: none;
  }

  &:hover ${PreviewWrapper} {
    display: block;
  }
`;

interface Props {
  children: JSX.Element | string;
  data: Insite.API.ActionEquip;
}

export const EquipPreview: React.FunctionComponent<Props> = ({
  children,
  data,
}) => {
  const [isVisible, setVisible] = React.useState(true);

  return isVisible ? (
    <Container>
      <PreviewWrapper>
        <Preview onChange={() => setVisible(false)} data={data} />
      </PreviewWrapper>
      <Trigger>{children}</Trigger>
    </Container>
  ) : null;
};
